/**
 * Collection of design tokens for consistent spacing and typography scaling. Base provides
 * foundational spacing, and typography ensures text scaling.
 */ const scales = {
    base: 4,
    typography: 'majorSecond'
};

export { scales };
//# sourceMappingURL=scales.js.map
